import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useState, cloneElement } from 'react';
import { Box, ClickAwayListener, Fade, makeStylesV5, Paper, Popper, Text } from '../index';
const useStyles = makeStylesV5()((theme, { arrowColor, backgroundColor }, classes) => {
    const color = backgroundColor || theme.palette.background.paper;
    return {
        popoverRoot: {
            backgroundColor: color,
            maxWidth: 1000,
            borderRadius: '8px !important'
        },
        content: {},
        popper: {
            zIndex: 2000,
            boxShadow: '0px 3px 25px #00000099',
            borderRadius: 8,
            [`&[data-popper-placement*="bottom"] .${classes.arrow}`]: {
                top: 0,
                left: 0,
                marginTop: -17,
                marginLeft: 4,
                marginRight: 4,
                ['&::before']: {
                    transformOrigin: '0 100%'
                }
            },
            [`&[data-popper-placement*="top"] .${classes.arrow}`]: {
                bottom: 0,
                left: 0,
                marginBottom: -17,
                marginLeft: 4,
                marginRight: 4,
                ['&::before']: {
                    transformOrigin: '100% 0'
                }
            },
            [`&[data-popper-placement*="right"] .${classes.arrow}`]: {
                left: 0,
                marginLeft: -17,
                height: 25,
                width: 17,
                marginTop: 4,
                marginBottom: 4,
                ['&::before']: {
                    transformOrigin: '100% 100%'
                }
            },
            [`&[data-popper-placement*="left"] .${classes.arrow}`]: {
                right: 0,
                marginRight: -17,
                height: 25,
                width: 17,
                marginTop: 4,
                marginBottom: 4,
                ['&::before']: {
                    transformOrigin: '0 0'
                }
            }
        },
        arrow: {
            overflow: 'hidden',
            position: 'absolute',
            width: 25,
            height: 17,
            boxSizing: 'border-box',
            color: arrowColor,
            ['&::before']: {
                content: '""',
                margin: 'auto',
                display: 'block',
                width: '100%',
                height: '100%',
                boxShadow: theme.shadows[1],
                backgroundColor: 'currentColor',
                transform: 'rotate(45deg)',
            }
        },
        belt: {
            minHeight: 12,
            backgroundColor: arrowColor,
            borderRadius: '4px 4px 0px 0px',
            display: 'block'
        },
        popperTitle: {
            padding: '10px 16px',
        }
    };
});
export default memo(({ id = '', placement = 'bottom', arrow = true, className, open, onClose = () => ({}), content, children, arrowColor = 'white', backgroundColor, title }) => {
    const { classes, cx } = useStyles({ arrowColor, backgroundColor });
    const [arrowRef, setArrowRef] = useState(null);
    const [childNode, setChildNode] = useState(null);
    return (_jsxs(_Fragment, { children: [cloneElement(children, Object.assign(Object.assign({}, children.props), { ref: setChildNode })), _jsx(Popper, Object.assign({ disablePortal: true, id: id, open: open, anchorEl: childNode, placement: placement, sx: {
                    '& .MuiPaper-root': {
                        borderRadius: '8px !important'
                    }
                }, transition: true, className: cx(classes.popper, className), modifiers: [
                    {
                        name: 'preventOverflow',
                        enabled: true,
                        options: {
                            altAxis: true,
                            altBoundary: true,
                            tether: true,
                            rootBoundary: 'document',
                            padding: 8,
                        },
                    },
                    {
                        name: 'arrow',
                        enabled: true,
                        options: {
                            element: arrowRef,
                            padding: 10,
                        },
                    }
                ] }, { children: ({ TransitionProps }) => (_jsx(Fade, Object.assign({}, TransitionProps, { timeout: 350 }, { children: _jsx(Paper, Object.assign({ elevation: 0 }, { children: _jsx(ClickAwayListener, Object.assign({ onClickAway: onClose }, { children: _jsxs(Paper, Object.assign({ elevation: 0, className: classes.popoverRoot }, { children: [arrow ? (_jsxs(_Fragment, { children: [_jsx("span", { className: classes.arrow, ref: setArrowRef }), _jsx("span", Object.assign({ className: classes.belt }, { children: title && _jsx(Text, Object.assign({ extraSmall: true, white: true, bold: true, className: classes.popperTitle }, { children: title })) }))] })) : null, _jsx(Box, Object.assign({ className: classes.content }, { children: content }))] })) })) })) }))) }))] }));
});
//# sourceMappingURL=index.js.map